import { useLocation, useNavigate } from 'react-router-dom';
import { Home, Calendar, Plus, Briefcase, User } from 'lucide-react';

export const BottomNav = ({ onQuickAdd, hideQuickAdd = false }) => {
    const location = useLocation();
    const navigate = useNavigate();
    
    const isActive = (path) => location.pathname === path;
    
    // Auto-hide quick add on pages where it has no function
    const pagesWithoutQuickAdd = ['/settings', '/profile'];
    const shouldHideQuickAdd = hideQuickAdd || pagesWithoutQuickAdd.includes(location.pathname);

    const navItems = [
        { icon: Home, label: 'Home', path: '/dashboard' },
        { icon: Calendar, label: 'Calendar', path: '/calendar' },
        { icon: Plus, label: 'Add', action: 'quickAdd', isCenter: true },
        { icon: Briefcase, label: 'Cases', path: '/cases' },
        { icon: User, label: 'Profile', path: '/profile' },
    ].filter(item => !(item.isCenter && shouldHideQuickAdd));

    const handleClick = (item) => {
        if (item.action === 'quickAdd') {
            onQuickAdd?.();
        } else if (item.path) {
            navigate(item.path);
        }
    };

    return (
        <nav 
            className="fixed bottom-10 left-1/2 -translate-x-1/2 z-50"
            data-testid="bottom-nav"
        >
            <div className="flex items-center gap-1 px-4 py-2 bg-white/90 backdrop-blur-xl rounded-full shadow-2xl border border-white/30">
                {navItems.map((item, index) => {
                    const Icon = item.icon;
                    const active = item.path && isActive(item.path);
                    
                    if (item.isCenter) {
                        return (
                            <button
                                key={index}
                                onClick={() => handleClick(item)}
                                className="mx-2 p-4 bg-[#1C6EE7] rounded-full text-white shadow-lg hover:shadow-xl transition-all active:scale-95"
                                data-testid="quick-add-btn"
                            >
                                <Icon className="h-6 w-6" />
                            </button>
                        );
                    }
                    
                    return (
                        <button
                            key={index}
                            onClick={() => handleClick(item)}
                            className={`p-3 rounded-full transition-all ${
                                active 
                                    ? 'bg-blue-100 text-[#1C6EE7]' 
                                    : 'text-slate-500 hover:text-slate-800 hover:bg-slate-100'
                            }`}
                            data-testid={`nav-${item.label.toLowerCase()}`}
                        >
                            <Icon className="h-5 w-5" />
                        </button>
                    );
                })}
            </div>
        </nav>
    );
};

export default BottomNav;
